import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_TRACKERTYPE_LOAD,
    ACTION_TRACKERTYPE_LOAD_BY_ID,

    ACTION_TRACKERTYPE_SAVE,

    ACTION_TRACKERTYPE_CREATE,

    ITrackerTypeLoadAction,
    ITrackerTypeLoadByIdAction,
    ITrackerTypeLoadFailureAction,
    ITrackerTypeLoadSuccessAction,

    ITrackerTypeSaveAction,
    ITrackerTypeSaveSuccessAction,
    ITrackerTypeSaveFailureAction,

    ITrackerTypeCreateAction,
    ITrackerTypeCreateSuccessAction,
    ITrackerTypeCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/trackerTypes";
import { trackerTypeApi } from "../services/trackerType";

export const
    getTrackerTypesEpic = (action$): Observable<ITrackerTypeLoadSuccessAction | ITrackerTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_LOAD)
            .mergeMap((action: ITrackerTypeLoadAction) => {
                return trackerTypeApi
                    .getTrackerTypes()
                    .map(response =>
                        LoadSuccess(response.trackerTypes, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrackerTypeByIdEpic = (action$): Observable<ITrackerTypeLoadSuccessAction | ITrackerTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_LOAD_BY_ID)
            .mergeMap((action: ITrackerTypeLoadByIdAction) => {
                return trackerTypeApi
                    .getTrackerTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.trackerType, response.formState, response.formProperties, response.formRoles, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrackerTypeEpic = (action$): Observable<ITrackerTypeSaveSuccessAction | ITrackerTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_SAVE)
            .mergeMap((action: ITrackerTypeSaveAction) => {
                return trackerTypeApi
                    .setTrackerType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trackerType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrackerTypeEpic = (action$): Observable<ITrackerTypeCreateSuccessAction | ITrackerTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_CREATE)
            .mergeMap((action: ITrackerTypeCreateAction) => {
                return trackerTypeApi
                    .createTrackerType()
                    .map(response =>
                        CreateSuccess(
                            response.trackerType,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



